import { render, staticRenderFns } from "./Camareira.vue?vue&type=template&id=3dca6881&scoped=true&"
import script from "./Camareira.vue?vue&type=script&lang=js&"
export * from "./Camareira.vue?vue&type=script&lang=js&"
import style0 from "./Camareira.vue?vue&type=style&index=0&id=3dca6881&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca6881",
  null
  
)

export default component.exports